import { IAppState, TActions } from '../../../common/state';

export const infrastructureReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    default:
      return state;
  }
};
